// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__mSHVG","slick-next":"CustomSlider_slick-next__Qmnfr"};